import ScreenRadarList from 'screens/Radar/List';
import ScreenRadarCreate from 'screens/Radar/Create';
import ScreenRadarDetail from 'screens/Radar/Details';
import ScreenRadarUpdate from 'screens/Radar/Update';
import { RADAR } from './paths';

const radarRoutes = [
  {
    path: RADAR.LIST,
    name: 'Lists',
    component: ScreenRadarList,
    allowPermissions: ['view_processorlistitem'],
  },
  {
    path: RADAR.CREATE,
    name: 'ListCreate',
    component: ScreenRadarCreate,
    allowPermissions: ['add_processorlistitem'],
  },
  {
    path: RADAR.DETAILS,
    name: 'ListDetail',
    component: ScreenRadarDetail,
    allowPermissions: ['view_processorlistitem'],
  },
  {
    path: RADAR.UPDATE,
    name: 'ListUpdate',
    component: ScreenRadarUpdate,
    allowPermissions: ['change_processorlistitem'],
  },
];

export default radarRoutes;
